/* eslint-disable import/no-import-module-exports */
import ModelUtil from '@leverege/model-util';
import ColumnModel from "./ColumnModel.js";
import Attributes from "../../attribute/Attributes.js";
import Formatters from "../../attribute/formatter/Formatters.js";
import I18nResolvers from "../../attribute/i18nResolver/I18nResolvers.js";
const VALUE_TYPE = 'boolean';
const TYPE = `attr.column.${VALUE_TYPE}`;
function getName(data) {
  return Attributes.getDisplayName(data.attrName, data.objectType);
}

// These are common, make them once
const base = {
  ...ColumnModel,
  getName,
  ...ModelUtil.createAllValue('formatter')
};
delete base.create;
function create(attrName, objectType) {
  return ColumnModel.create(TYPE, {
    attrName,
    objectType,
    formatter: Formatters.createFormatterModel(VALUE_TYPE),
    i18nResolver: I18nResolvers.createI18nResolverModel(VALUE_TYPE)
  });
}
export default {
  TYPE,
  create,
  ...base
};